var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLifeChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.333 17.283v2.409c0 4.462-2.55 6.375-6.375 6.375H9.208c-3.825 0-6.375-1.913-6.375-6.375v-7.65c0-4.463 2.55-6.375 6.375-6.375h3.825a5.46 5.46 0 00-.283 1.77v5.526c0 1.374.453 2.535 1.26 3.343.808.807 1.97 1.26 3.344 1.26v1.97c0 .723.822 1.162 1.43.765l4.095-2.734h3.683c.638 0 1.233-.1 1.771-.284z",
    stroke: "#DD0510",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.167 7.437v5.526c0 2.11-1.077 3.697-2.834 4.32a5.462 5.462 0 01-1.77.284h-3.684L18.785 20.3c-.61.396-1.43-.043-1.43-.765v-1.97c-1.375 0-2.537-.453-3.344-1.26-.808-.808-1.261-1.97-1.261-3.344V7.438c0-.637.1-1.232.283-1.77.624-1.757 2.21-2.834 4.321-2.834h9.209c2.762 0 4.604 1.842 4.604 4.604zM10.483 31.167h10.2M15.583 26.067v5.1",
    stroke: "#DD0510",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.202 10.27h.013M22.235 10.27h.013M18.268 10.27h.013",
    stroke: "#DD0510",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLifeChat);
export default __webpack_public_path__ + "static/media/life-chat.1028994783f0ae2b7afc74b8a905bcfb.svg";
export { ForwardRef as ReactComponent };